import { render, staticRenderFns } from "./Politicas.vue?vue&type=template&id=56ccc560&scoped=true"
import script from "./Politicas.vue?vue&type=script&lang=js"
export * from "./Politicas.vue?vue&type=script&lang=js"
import style0 from "./Politicas.vue?vue&type=style&index=0&id=56ccc560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ccc560",
  null
  
)

export default component.exports